/*
 * @Author: yang
 * @Date: 2024-07-17 09:27:35
 * @LastEditors: Please set LastEditors
 * @LastEditTime: 2024-08-22 10:25:01
 * @Description: 新闻类型
 */

import request from '@/utils/request'
let baseUrl ='/carbon/newsType'

/**
 * @description: 获取新闻类型列表
 * @return {*}
 */
export async function listPageNewsTypem(data) {
    return await request({
        url: baseUrl+'/listPage',
        headers: {
            isToken: true
        },
        method: 'post',
        data:data,
        timeout: 20000
    })
}

/**
 * @description: 添加新闻类型
 * @return {*}
 */
export async function addNewsTypem(data) {
    return await request({
        url: baseUrl+'/add',
        headers: {
            isToken: true
        },
        method: 'post',
        data:data,
        timeout: 20000
    })
}

/**
 * @description: 编辑新闻类型
 * @return {*}
 */
export async function updateNewsTypem(data) {
    return await request({
        url: baseUrl+'/update',
        headers: {
            isToken: true
        },
        method: 'post',
        data:data,
        timeout: 20000
    })
}

/**
 * @description: 批量删除新闻类型
 * @return {*}
 */
export async function deleteNewsTypem(data) {
    return await request({
        url: baseUrl+'/deleteBatch',
        headers: {
            isToken: true
        },
        method: 'post',
        data:data,
        timeout: 20000
    })
}



